import { post } from "~/common/request"

export const createOrReusePayment = (
  params: API.Payment.CreateOrReusePaymentParams,
  signal?: AbortSignal,
) => {
  return post<API.Payment.CreateOrReusePaymentResponse>(
    "/api/payment/create_or_reuse",
    params,
    { signal },
  )
}

export const getPaymentStatus = (
  params: API.Payment.PaymentStatusParams,
  signal?: AbortSignal,
) => {
  return post<API.Payment.PaymentStatusResponse>(
    "/api/payment/status",
    params,
    { signal },
  )
}
